import {
  AppBar,
  Container,
  Paper,
  Tab,
  Tabs,
  Toolbar,
  Typography,
} from "@mui/material";
import { Link, Outlet, useLocation } from "react-router";
import ManagerStatus from "./components/ManagerStatus";

const Layout: React.FC = () => {
  const location = useLocation();

  console.log(location);

  return (
    <Container maxWidth="md">
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            Minecraft @ Atfares 17
          </Typography>
          <ManagerStatus />
        </Toolbar>
      </AppBar>
      <Tabs value={location.pathname === "/" ? false : location.pathname}>
        <Tab label="Worlds" value="/worlds" to="/worlds" component={Link} />
        <Tab
          label="Versions"
          value="/versions"
          to="/versions"
          component={Link}
        />
        <Tab label="Users" value="/users" to="/users" component={Link} />
      </Tabs>
      <Paper sx={{ padding: "20px 20px", marginTop: "20px" }}>
        <Outlet />
      </Paper>
    </Container>
  );
};

export default Layout;
